export enum AnimalContactTypeEnum {
  FINDER = 'finder',
  OWNER = 'owner',
  GIVER = 'giver',
  AUTHORIZED_PICKUP = 'authorized_pickup',
  SUPERVISOR = 'supervisor',
  SON_DAUGHTER = 'son_daughter',
  PARTNER = 'partner',
  PARENT = 'parent',
  BROTHER_SISTER = 'brother_sister',
  PERSON_TAKING_OVER = 'person_taking_over',
  NEIGHBOR = 'neighbor',
  ADDITIONAL_PARTY = 'additional_party',
  FOSTER_FAMILY = 'foster_family',
  TRIAL_FAMILY = 'trial_family'
}
